import { useState } from 'react';
import iWillLogo from '../../assets/iWillLogo.png';
import { Icon, Icons } from 'components/Icon';
import Sidebar from './Sidebar';
import { UserInfoDto } from 'service/dto/user.dto';

type Props = {
  user: UserInfoDto | null;
};

const LandingMenuMobile = ({ user }: Props) => {
  const [show, setShow] = useState<boolean>(false);
  return (
    <>
      <div className=" mx-7 flex h-full items-center tablet:hidden sm:py-3 md:py-2 ">
        <button onClick={() => setShow(!show)} type="submit">
          <Icon name={Icons.Hamburger} />
        </button>
        {user && user.email && (
          <p className="ml-6 grow text-primary-800">Hi {user.othername}</p>
        )}
        <div className="ml-10 1xl:mr-10">
          <img src={iWillLogo} alt="iWill" className="h-10 w-32" />
        </div>
      </div>
      {show && (
        <Sidebar
          name={user ? user.othername : null}
          initials="AS"
          email={user ? user.email : null}
          setShow={() => setShow(false)}
          show={show}
        />
      )}
    </>
  );
};

export default LandingMenuMobile;
